(function() {
    'use strict';

    angular.module('app.vacacionesDetalle', []);
})();
